<!-- Confirmation Dialog -->
<div class="modal-backdrop" *ngIf="isVisible"></div>
<div class="modal" *ngIf="isVisible">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{data?.title}}</h5>
      <button type="button" class="close" (click)="cancel()">×</button>
    </div>
    <div class="modal-body">
      <p>{{ data?.message }}</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
      <button class="btn btn-primary" (click)="confirm()">Confirm</button>
    </div>
  </div>
</div>
